import React, { Fragment } from 'react'
import Button from 'components/Button'
import ErrorMessage from 'utils/ErrorMessage'
import UploadIcon from 'components/icons/UploadIcon'
import Control from 'components/Control/Control'

import Add from 'components/icons/Add'
import { uploadFile, deleteFile } from 'modules/Drive/actions'
import { useDispatch } from 'react-redux'
import {
  Wrapper,
  StyledUpload,
  AdjustIcon,
  Cirlcle,
  SpanText,
  TextWrapper,
  UploadText,
  AddIcon,
  SmallButtons,
  StyledH2,
} from 'components/Uploader/Styles'
import RepeatIcon from 'components/icons/RepeatIcon'

const Uploader = ({
  isDelete,
  file,
  setFile,
  isDefault = false,
  showTextUploder,
  showButtonUploder,
  showIconUploader,
  customUploader = false,
  fileName,
  defaultButtonTrigger,
  bgcolor='#fafafb',
  borderColor='#cccfd6',
  height = 'auto',
  format 
}) => {
  const dispatch = new useDispatch()

  const getFileUrl = async info => {
    let getType = info?.file?.type?.includes('png') ? 'png' : 'jpg'
    let name = fileName + '.' + getType
    let response = await dispatch(uploadFile(info?.file?.originFileObj, name))
    if (response) {
      setFile(response)
    }
  }

  const props = {
    name: 'file',
    multiple: false,
    listType: 'picture',
    accept: '.jpeg, .jpg , .png',
    beforeUpload: file => {
      const isLt10mb = file.size / 1024 / 1024 < 10
      if (!isLt10mb) {
        ErrorMessage('Image must smaller than 10mb!')
        return false
      } else if (
        !(file?.type?.includes('png') || file?.type?.includes('jpeg'))
      ) {
        ErrorMessage('File should be in jpg/jpeg or png format!')
        return false
      }
    },
    onChange: async info => {
      if (isDelete && info?.file?.status === 'done') {
        let response = await dispatch(deleteFile(file))
        if (response) {
          return getFileUrl(info)
        }
      } else if (!isDelete && info?.file?.status === 'done') {
        return getFileUrl(info)
      }
    },
    itemRender: () => {},
  }

  const dummyRequest = ({ file, onSuccess }) => {
    setTimeout(() => {
      onSuccess('OK')
    }, 0)
  }

  const onBeforeUpload = file => {
    const isLt10mb = file.size / 1024 / 1024 < 10
    if (!isLt10mb) {
      ErrorMessage('Image must smaller than 10mb!')
      return false
    } else if (!(file?.type?.includes('pdf') || file?.type?.includes('jpeg'))) {
      ErrorMessage('File should be in jpg/jpeg or pdf format!')
      return false
    }
  }

  const onChangeFileUpload = async info => {
    if (info?.file?.status === 'done') {
      let getType = info?.file?.type?.includes('pdf') ? 'pdf' : 'jpg'
      let name = fileName + '.' + getType
      let response = await dispatch(uploadFile(info?.file?.originFileObj, name))
      if (response) {
        let fileObject = {
          name: name,
          url: response,
          size: info?.file?.size,
          date: new Date().getTime(),
          type: getType,
        }
        setFile(fileObject)
      }
    }
  }

  return (
    <Fragment>
      {isDefault &&
        (defaultButtonTrigger ? (
          <StyledUpload
            {...props}
            type="file"
            accept={'.jpeg, .jpg , .pdf'}
            customRequest={dummyRequest}
            onChange={onChangeFileUpload}
            beforeUpload={onBeforeUpload}
          >
            {defaultButtonTrigger}
          </StyledUpload>
        ) : (
          <Wrapper center ali gnCenter column>
            <StyledUpload
              {...props}
              type="file"
              accept={'.jpeg, .jpg , .pdf'}
              customRequest={dummyRequest}
              onChange={onChangeFileUpload}
              beforeUpload={onBeforeUpload}
            >
              <Button.Secondary
                icon={
                  <AdjustIcon>
                    <UploadIcon />
                  </AdjustIcon>
                }
                text="Upload File"
                height={'32px'}
              />
            </StyledUpload>
            <TextWrapper center alignCenter>
              <SpanText>Size: 10 mb max</SpanText> <Cirlcle />
              <SpanText>Format : .PDF, .JPEG/JPG</SpanText>
            </TextWrapper>
          </Wrapper>
        ))}
      {showTextUploder && (
        <StyledUpload {...props} type="file" customRequest={dummyRequest}>
          <Control center alignCenter top="5px">
            <AddIcon>
              <Add />
            </AddIcon>
            <UploadText>Upload Photo</UploadText>
          </Control>
        </StyledUpload>
      )}
      {showButtonUploder && (
        <StyledUpload {...props} type="file" customRequest={dummyRequest}>
          <Button.Primary text="Change Image" height={'32px'} />
        </StyledUpload>
      )}
      {showIconUploader && (
        <StyledUpload {...props} type="file" customRequest={dummyRequest}>
          <RepeatIcon />
        </StyledUpload>
      )}
      {customUploader && (

<Wrapper center alignCenter column bgcolor={bgcolor} borderColor={borderColor} height={height}>
<StyledUpload
  {...props}
  type="file" 
  accept={'.jpeg, .jpg , .png'}
  customRequest={dummyRequest}
  onChange={onChangeFileUpload}
  beforeUpload={onBeforeUpload}
>
  <SmallButtons
    height={'38px'}
    width="38px"
    border={true}
    icon={<UploadIcon />}
  />
</StyledUpload>
<TextWrapper center alignCenter>
  <StyledH2>Browse for file or Drag and drop </StyledH2>
</TextWrapper>
<TextWrapper center alignCenter padding={'9px 0px'}>
  {}
  <SpanText>Format {format ?? ': .xlsx'}</SpanText>
</TextWrapper>
</Wrapper>
      )

      }
    </Fragment>
  )
}

export default Uploader
